import React, { useCallback, useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import "../courseStyles.css";
import CaSideNav from "../../../../components/AdminComponents/CaSideNav";
import Sidebar from "../../../../components/AdminComponents/SideNav";
import {
  CourseTopLevel,
  CourseTopLevelCA,
} from "../../../../components/AdminComponents/MenuItems";
import { Card, Typography, Tag, Divider, Tooltip, Collapse } from "antd";
import {
  FilePdfOutlined,
  FileImageOutlined,
  FileTextOutlined,
  // BookOutlined,
  UpOutlined,
  DownOutlined,
  VideoCameraOutlined,
} from "@ant-design/icons";
// import { IMAGE_LINK } from "../../../../config";
// eslint-disable-next-line no-unused-vars
import { MAIN_LOGO_BIG, SLIDER_IMAGE_1 } from "../../../../ImagesSrc";
import {
  capitalizeWords,
  remainingViewportHeight,
} from "../../../../components/icons/ApplicationColor";
import axiosInstance from "../../../../api/Axios";
import useCommonListing from "../../../../components/AdminComponents/customHooks/useCommonListing";
import {
  getCleanFileName,
  getFileType,
  getFileTypeColor,
} from "../courseUtils";
import FilePreviewerCynter from "../../../../components/FilePreviewerCynter";
const { Panel } = Collapse;
const { Title, Text } = Typography;

const CoursePreview = () => {
  const { id } = useParams();
  const location = useLocation();
  const isCAAdmin = location.pathname.includes("ca-admin");
  const WrapperComponent = isCAAdmin ? CaSideNav : Sidebar;
  const wrapperProps = isCAAdmin ? CourseTopLevelCA : CourseTopLevel;
  const [data1, setData1] = useState([]);
  const [loading, setLoading] = useState(true);
  const LoadUser = useCallback(async () => {
    try {
      const res = await axiosInstance.get(`/courselist/${id}/`);
      setData1(res.data);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  }, [id]);

  useEffect(() => {
    LoadUser();
  }, [LoadUser]);
  const { data, loading: loading2 } = useCommonListing({
    passSize: 50,
    passPage: 1,
    passURL: `/coursedetailslist/${id}/`,

    // includeStatus: false,
  });
  console.log(loading2, data, data1, loading);
  const getFileIcon = (fileName = "") => {
    const ext = fileName.split(".").pop().toLowerCase(); // get last part after '.'
    if (ext === "pdf")
      return <FilePdfOutlined style={{ fontSize: 27, color: "#ff4d4f" }} />;

    if (["png", "jpg", "jpeg", "gif", "webp"].includes(ext))
      return <FileImageOutlined style={{ fontSize: 27, color: "#52c41a" }} />;

    if (["mp4", "mov", "avi", "mkv"].includes(ext))
      return <VideoCameraOutlined style={{ fontSize: 27, color: "#722ed1" }} />;

    return <FileTextOutlined style={{ fontSize: 27, color: "#1890ff" }} />;
  };

  const [activeKey, setActiveKey] = useState(null);
  // Transform your API response
  const courseFiles = data?.flatMap((course) =>
    course.attachment.map((att) => ({
      id: course.id,
      courseName: course.name,
      type: course.type,
      fileName: att.file_name.split("/").pop(), // just the actual filename
      url: att.url,
    }))
  );
  console.log(courseFiles);
  const [selectedFile, setSelectedFile] = useState();
  return (
    <WrapperComponent props={wrapperProps}>
      <div
        style={{
          background: "#f4f4f4",
          width: "100%",
          height: remainingViewportHeight(10),
          display: "flex",
          justifyContent: "center",
          alignItems: "flex-start",
          padding: "24px",
          overflowY: "auto",
          gap: "24px",
          marginTop: "50px",
          overflow: "hidden",
        }}
      >
        <div style={{ flexBasis: "20%", height: "100%" }}>
          <Card
            bordered={false}
            style={{
              flex: "0 0 30%",
              borderRadius: "16px",
              boxShadow: "0 4px 14px rgba(0,0,0,0.06)",
              background: "#fff",
              padding: "5px 24px",
              height: "100%",
              overflowY: "auto",
              // overflowx: "hidden",
            }}
          >
            <Title
              // level={}
              style={{
                fontSize: "15.5px",
                textAlign: "center",
                width: "100%",
                // display: "block",
                fontWeight: "600",
                letterSpacing: 0.5,
                color: "#333333",
              }}
            >
              Course Preview
            </Title>

            <Divider />
            <div
              style={{
                display: "flex",
                gap: "20px",
                flexWrap: "wrap",
                justifyContent: "center",
                width: "100%",
              }}
            >
              {courseFiles.map((file, index) => {
                const isSelected = selectedFile?.fileName === file.fileName;
                return (
                  <Tooltip title={file.name} key={file.name}>
                    <div
                      onClick={() => setSelectedFile(file)}
                      style={{
                        width: "100%",
                        height: "100px",
                        borderRadius: "14px",
                        border: isSelected
                          ? "2px solid #1890ff"
                          : "1px solid #e5e5e5",
                        background: isSelected ? "#f0f8ff" : "#fafafa",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        cursor: "pointer",
                        transition: "all 0.3s ease",
                        position: "relative",
                        boxShadow: isSelected
                          ? "0 6px 16px rgba(24,144,255,0.25)"
                          : "0 2px 8px rgba(0,0,0,0.05)",
                      }}
                    >
                      {/* Step Badge - circular floating badge */}
                      <div
                        style={{
                          position: "absolute",
                          top: -8,
                          right: -8,
                          background: isSelected ? "#1890ff" : "#aaa",
                          color: "#fff",
                          width: "22px",
                          height: "22px",
                          borderRadius: "50%",
                          fontSize: "11px",
                          fontWeight: 600,
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                        }}
                      >
                        {index + 1}
                      </div>

                      {getFileIcon(file.fileName)}
                      <span
                        style={{
                          fontSize: "14px",
                          fontWeight: 500,
                          marginTop: "15px",
                          textAlign: "center",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          width: "90%",
                        }}
                      >
                        {file.courseName}
                      </span>
                    </div>
                  </Tooltip>
                );
              })}
              {false && (
                <Collapse
                  bordered={false}
                  activeKey={activeKey}
                  onChange={(key) => setActiveKey(key)}
                  expandIcon={({ isActive }) => (isActive ? null : null)}
                  style={{ width: "100%" }}
                >
                  <Panel
                    key="multi-step"
                    header={
                      <div
                        style={{
                          height: "100px",
                          borderRadius: "14px",
                          border: "1px solid #e5e5e5",
                          background: "#fafafa",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontSize: "14px",
                          fontWeight: 500,
                          position: "relative",
                          boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
                          cursor: "pointer",
                        }}
                      >
                        {/* Step badge */}
                        <div
                          style={{
                            position: "absolute",
                            top: -8,
                            right: -8,
                            background: "#aaa",
                            color: "#fff",
                            width: "22px",
                            height: "22px",
                            borderRadius: "50%",
                            fontSize: "11px",
                            fontWeight: 600,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                          }}
                        >
                          4
                        </div>
                        Step with Multiple Files
                        {/* Arrow inside card (bottom-right corner) */}
                        <div
                          style={{
                            position: "absolute",
                            right: 12,
                            bottom: 12,
                          }}
                        >
                          {activeKey === "multi-step" ? (
                            <UpOutlined
                              style={{ fontSize: 16, color: "#555" }}
                            />
                          ) : (
                            <DownOutlined
                              style={{ fontSize: 16, color: "#555" }}
                            />
                          )}
                        </div>
                      </div>
                    }
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "10px",
                        marginTop: "10px",
                      }}
                    >
                      <div
                        style={{
                          padding: "10px",
                          border: "1px solid #e5e5e5",
                          borderRadius: "8px",
                          background: "#fff",
                        }}
                      >
                        Chapter-A.pdf
                      </div>
                      <div
                        style={{
                          padding: "10px",
                          border: "1px solid #e5e5e5",
                          borderRadius: "8px",
                          background: "#fff",
                        }}
                      >
                        Chapter-B.png
                      </div>
                      <div
                        style={{
                          padding: "10px",
                          border: "1px solid #e5e5e5",
                          borderRadius: "8px",
                          background: "#fff",
                        }}
                      >
                        Notes.docx
                      </div>
                    </div>
                  </Panel>
                </Collapse>
              )}
            </div>
          </Card>
        </div>
        <div style={{ flexBasis: "80%", display: "flex", height: "100%" }}>
          {/* Top Preview Card */}
          <Card
            bordered={false}
            style={{
              flex: "0 0 97.5%",
              width: "100%",
              borderRadius: "16px",
              boxShadow: "0 6px 20px rgba(0,0,0,0.08)",
              background: "#fff",
              padding: "10px 28px",
              display: "flex",
              flexDirection: "column",
              overflow: "auto",
              height: "100%",
              // padding:"10px"
            }}
            // className="no-padding-no-margin"
          >
            {/* Top Row - Title + Metadata + Tag all in one line */}
            <Card
              bordered={false}
              style={{
                borderRadius: "16px",
                boxShadow: "0 6px 14px rgba(0,0,0,0.06)",
                padding: "0 0 12px",
                background: "#fafafa",
              }}
              className="no-padding-no-margin"
              hoverable
            >
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr auto", // three zones: left, middle, right
                  rowGap: 10,
                  padding: "8px 10px",
                  alignItems: "center",
                }}
              >
                {/* Course */}
                <div style={{ display: "flex", gap: 4 }}>
                  <Text
                    type="secondary"
                    style={{ fontSize: 14, fontWeight: 500 }}
                  >
                    Course :
                  </Text>
                  <Text style={{ fontSize: 15, color: "#333" }}>
                    {data1?.name}
                  </Text>
                </div>

                {/* Language */}
                <div style={{ display: "flex", gap: 4 }}>
                  <Text
                    type="secondary"
                    style={{ fontSize: 14, fontWeight: 500 }}
                  >
                    Language :
                  </Text>
                  <Text style={{ fontSize: 15, color: "#333" }}>
                    {data1?.language}
                  </Text>
                </div>

                {/* Mode */}
                <Tag
                  color="purple"
                  style={{
                    fontSize: 13,
                    padding: "4px 12px",
                    borderRadius: 20,
                    fontWeight: 500,
                    background: "#f9f0ff",
                    color: "#722ed1",
                    justifySelf: "end",
                  }}
                >
                  {data1?.mode}
                </Tag>

                {/* Divider spans full row */}
                <Divider style={{ gridColumn: "1 / -1", margin: 0 }} />

                {/* Step Name */}
                <div style={{ display: "flex", gap: 4 }}>
                  <Text
                    type="secondary"
                    style={{ fontSize: 14, fontWeight: 500 }}
                  >
                    Step Name :
                  </Text>
                  <Text style={{ fontSize: 15, color: "#333" }}>
                    {selectedFile?.courseName}
                  </Text>
                </div>

                {/* File Name */}
                <div style={{ display: "flex", gap: 4 }}>
                  <Text
                    type="secondary"
                    style={{ fontSize: 14, fontWeight: 500 }}
                  >
                    File Name :
                  </Text>
                  <Text style={{ fontSize: 15, color: "#333" }}>
                    {getCleanFileName(selectedFile?.fileName)}
                  </Text>
                </div>

                {/* File Type Tag */}
                <Tag
                  color={getFileTypeColor(selectedFile?.url)}
                  style={{
                    fontSize: 13,
                    padding: "4px 12px",
                    borderRadius: 20,
                    fontWeight: 500,

                    justifySelf: "end",
                  }}
                >
                  {capitalizeWords(getFileType(selectedFile?.url, true))}
                </Tag>
              </div>
            </Card>

            {/* <Divider style={{ margin: "12px 0" }} /> */}

            {/* Preview Area */}
            <div style={{ height: "600px", border: "1px solid #eee" }}>
              <FilePreviewerCynter
                fileUrl={selectedFile?.url}
                zoomPercent={120}
                rotation={0}
                isImage={false}
                isReadyToRender={true}
              />
            </div>
          </Card>

          {/* File Selector */}
        </div>
      </div>
    </WrapperComponent>
  );
};

export default CoursePreview;
